import React, { forwardRef } from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  variant?: 'primary' | 'outline';
  fullWidth?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  fullWidth,
  href,
  onClick,
  children,
  ...props
}, ref) => {
  const handleScroll = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
      return;
    }
    if (!href) {
      e.preventDefault();
      const target = document.getElementById('compra');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      window.location.href = href;
    }
  };
  return <button ref={ref} onClick={handleScroll} className={cn('inline-flex items-center justify-center rounded-md text-base font-bold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', 'px-8 py-4 shadow-lg hover:shadow-xl hover:-translate-y-1', variant === 'primary' && 'bg-brand-gold text-white hover:bg-brand-gold-light', variant === 'outline' && 'border-2 border-brand-gold text-brand-gold hover:bg-brand-gold/10', fullWidth && 'w-full', className)} {...props} data-id="element-161">
        {children}
      </button>;
});
Button.displayName = 'Button';